import { Button } from '@core/ui';

import { AddPollButtonProps } from './types';

export const AddPollButton = ({ children, ...props }: AddPollButtonProps) => (
    <Button type="button" variant="primary" classNames="group" data-testid="add-poll-button-test" {...props}>
        {children}
    </Button>
);
